import { useContext } from "react"
import { toast } from "react-toastify"
import * as Sentry from "@sentry/nextjs"
import { Button, Modal } from "react-bootstrap"
import { ACTION_TYPE, AppContext } from "AppContext"
import { MeDocument, PaymentMethod, useStudentCreateOrderMutation } from "@generated/graphql"

export default function ProductCheckoutModal() {
  const { state, dispatch } = useContext(AppContext)
  const [studentCreateOrderMutation] = useStudentCreateOrderMutation()

  return (
    <Modal
      size="lg"
      centered
      show={!!state.checkout?.product.id}
      aria-labelledby="contained-modal-title-vcenter"
      fullscreen="md-down"
      onHide={() => {
      }} keyboard={false}>
      <Modal.Header closeButton>
        {`Buy ${state.checkout?.product.name}`}
      </Modal.Header>
      <Modal.Body>
        Are you sure, you want to buy using coins?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => {
          dispatch({
            type: ACTION_TYPE.SET_PRODUCT_CHECKOUT, payload: null
          })
        }}>Cancel</Button>
        <Button variant="primary" onClick={() => {
          studentCreateOrderMutation({
            variables: {
              data: {
                products: [state.checkout!.product.id],
                paymentMethod: PaymentMethod.COIN
              }
            },
            refetchQueries: [{
              query: MeDocument
            }]
          }).then(res => {
            if (res.data?.studentCreateOrder?.success) {
              toast("Congratulations! You've claimed your reward. We'll soon reach out to you for more details!", {
                type: "success",
              })
            } else {
              Sentry.captureException(res.data?.studentCreateOrder?.message)
              toast(res.data?.studentCreateOrder?.message || "Something went wrong, please try again after sometime!", {
                type: "error"
              })
            }
            dispatch({
              type: ACTION_TYPE.SET_PRODUCT_CHECKOUT, payload: null
            })
          }).catch(error => {
            Sentry.captureException(error)
            toast("Something went wrong, please try again after sometime!", {
              type: "error"
            })
          })
        }}>Confirm</Button>
      </Modal.Footer>
    </Modal>
  )
}
